import axios from "axios";
import { deleteToken, getToken } from "./token-helpers";

const clienteAxios = axios.create({
  baseURL: "https://gw-clientes.mundopacifico.cl/",
});

clienteAxios.interceptors.request.use(
  function (config) {
    const token = getToken();

    if (token) {
      config.headers["authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    if (error.response.status === 401) {
      deleteToken();
    }
    return Promise.reject(error);
  }
);

clienteAxios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status === 401) {
      deleteToken();
    } else {
      return Promise.reject(error);
    }
  }
);

export default clienteAxios;
